import React, { useState} from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../_uiComponents/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import { UiGridType } from "../../../_uiComponents/common/DataGridComponents";
import { Grid } from "@mui/material";
import UiInput from "../../_uiComponents/UiInput";

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function Permissions(props) {
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(3);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage);
     };
     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(+event.target.value);
          setPage(0);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          console.log(property)
          const isAsc = orderBy === property && order === "asc";
          console.log(isAsc)
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     const headings = [
          { id: "name", name: "Permission Category" },
          { id: "label", name: "Permission" },
     ];

     const data = [
          {
               id: 1,
               name: "Campaign 1",
               label: ["sales1"],
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                    },
               ],
          },
          {
               id: 2,
               name: "Campaign 2",
               label: "sales2",
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
          {
               id: 3,
               name: "Campaign 3",
               label: "sales3",
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
     ];

     //Empty rows issue set
     const emptyRows =
          page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;
     console.log(emptyRows);
    

     //Data sorting
     const visibleRows = React.useMemo(
          () =>
               stableSort(data, getComparator(order, orderBy)).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
               ),
          [order, orderBy, page, rowsPerPage, data],
     );

     const [nodes, setNodes] = useState(data);
     const actionFilter = (keyword) => {       
        var list = data.filter(row => row.data.name.includes(keyword))
        console.log(list)
        setNodes(list)
    }

     return (
          <>         
               <div className="sba-table-main-wr sba-permission-grid">
               <Grid container>
                    <Grid item xs={12} lg={4} >
                        <UiInput type="search" label="Filter by name" onInput={(e) => actionFilter(e.target.value)}/>
                    </Grid>
                </Grid>
                    <UiTableWrapper>
                         <UiTableHead
                              headings={headings}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />
                         <UiTableBody>
                              {visibleRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             <TableCell align="left" width={'30%'} className="sba-permission-grid-name">
                                                  <strong>{row.name}</strong>
                                             </TableCell>
                                             <TableCell align="left" width={'70%'}> 
                                                <div className="sba-permission-grid-content">                                          
                                                <UiGridType
                                                       name={row.label}
                                                       
                                                  />
                                                  <UiGridType
                                                       name={row.label}                                                       
                                                  />                                                
                                                  </div> 
                                             </TableCell>                                            
                                        </TableRow>
                                   </>
                              ))}                            
                         </UiTableBody>                        
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />               
          </>
     );
}
